import React from 'react';
import './PageSection.css';

export interface PageSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: 'narrow' | 'default' | 'wide' | 'full';
  padding?: 'compact' | 'default' | 'comfortable';
}

export const PageSection: React.FC<PageSectionProps> = ({
  width = 'wide',
  padding = 'default',
  className = '',
  children,
  ...props
}) => {
  const classNames = [
    'ui-page-section',
    `ui-page-section--width-${width}`,
    `ui-page-section--padding-${padding}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

PageSection.displayName = 'PageSection';
